import { TextField, Button, FormControl } from "@material-ui/core";
import { observer, inject } from "mobx-react";
import { useState, useEffect } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { setResponsibleManagerPanel } from "../../helper/constants";

const QarResponsibleManager = inject("RootStore")(
  observer(({ RootStore, ...props }) => {
    useEffect(() => {
      props.accountData.responsibleManagerId
        ? setIsAccountAlreadySet(true)
        : setIsAccountAlreadySet(false);
    }, []);

    const [managerId, setManagerId] = useState(null);
    const [isAccountAlreadySet, setIsAccountAlreadySet] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const getManagersList = () => {
      const managers = RootStore.qarStore.allManagers.map((option) => ({
        id: option.id,
        firstName: option.firstName,
        secondName: option.secondName,
        surname: option.surname,
      }));
      return managers;
    };

    const handleSaveClick = () => {
      const data = {
        accountId: props.accountData.id,
        managerId: managerId,
      };
      RootStore.qarStore.setResponsibleManager(data);
      managerId ? setIsAccountAlreadySet(true) : setIsAccountAlreadySet(false);
      setShowModal(false);
    };

    const handleOnChange = (e, value) => {
      if (value === null || value === "") {
        setManagerId(null);
        return;
      }
      setManagerId(value.id);
    };

    const getManagerNames = (manager) => {
      return [manager.firstName, manager.secondName, manager.surname].join(" ");
    };

    if(RootStore.qarStore.allManagers.length === 0){
      return <></>
    }

    return (
      <div className="qar-admin-responsible-manager">
        <FormControl style={{width:"100%"}}>
          <Autocomplete
            fullWidth
            defaultValue={props.accountData.responsibleManagerId ? getManagersList().find(m => m.id === props.accountData.responsibleManagerId) : ""}
            onChange={(e, value) => handleOnChange(e, value)}
            options={getManagersList()}
            getOptionLabel={(option) => getManagerNames(option)}
            renderInput={(params) => <TextField {...params} />}
          />
        </FormControl>
        <Button
          style={{
            marginLeft: "20px",
          }}
          variant="contained"
          color="primary"
          onClick={(ev) => setShowModal(true)}
        >
          {isAccountAlreadySet ? "Edit" : "Save"}
        </Button>
        <ConfirmationModal
          content={setResponsibleManagerPanel.modalHeader}
          header={setResponsibleManagerPanel.modalContent}
          submitFunction={handleSaveClick}
          onClose={() => setShowModal(false)}
          show={showModal}
        />
      </div>
    );
  })
);

export default QarResponsibleManager;
